import React from 'react';
import { useSelector } from 'react-redux';

import { getUnreadConversations } from 'components/chat/dashboard/utils';
import { getUnreadConversationsCount } from 'modules/chat/selectors/dashboard';
import Badge from 'ui/base/Badge';

const ChatMenuItem = ({ className, ...props }) => {
  const unreadConversationsCount = useSelector(getUnreadConversationsCount);
  const displayCount = React.useMemo(() => getUnreadConversations(unreadConversationsCount), [unreadConversationsCount]);

  return (
    <Badge
      size="small"
      count={displayCount}
      {...props}
      className={className}
    >
      <i className="text-xl fb-icon fb-icon--ext-chat" />
    </Badge>
  );
};

export default ChatMenuItem;
